<template>
	<li class="item pb-3 pt-3 border-bottom-1" :class="{ 'invalid' : !item.valid}">

		<DeleteConfirmation :item_uuid="item.uuid"/>

		<div class="product-image-wrapper">
			<Link :href="route('product.geturl', {
				product_uuid : item.product_uuid
			})">
				<img class="product_image" :src="'/storage/product_image' + item.image" alt="">
			</Link>
		</div>
		<div class="details d-flex flex-column">

			<span class="invalid" v-if="!item.valid">
				<i class="lnr icon-warning"></i> {{__('product_no_longer_available')}}
			</span>

			<Link :href="route('product.geturl', {
				product_uuid : item.product_uuid
			})">
			<span class="title">
				{{ item.title }}
			</span>
			</Link>

			<div class="d-flex flex-column flex-xs-row justify-content-between">

				<div>
					<span class="price">{{ (item.price_new * item.quantity).toFixed(2)  }} {{ $page.props.store.currency_symbol || $page.props.store.currency_code }}</span>
					<span class="old-price text-small font-light text-decoration-line-through ps-1" v-if="item.price_old > item.price_new"> {{ (item.price_old * item.quantity).toFixed(2) }} {{ $page.props.store.currency_symbol || $page.props.store.currency_code }} </span>
				</div>

				<div class="controls">

					<button class="delete" v-if="options.delete_button" @click="showDeleteConfirmation">
						{{__('remove')}}
						 <i class="right lnr icon-trash"></i>
					</button>

					<QuantityControl v-model="quantity" :max="10000" v-if="options.quantity_controls"/>

					<span class="quantity" v-else>
					{{ quantity }} {{__('pcs')}}

				</span>

				</div>

			</div>

			<span class="sku" v-if="item.product_sku">
				SKU: {{ item.product_sku }}
			</span>

		</div>
	</li>
</template>

<script>

import {Link} from "@inertiajs/vue3";
import QuantityControl from "@/Components/ECart/Reusable/QuantityControl.vue";
import DeleteConfirmation from "@/Components/ECart/Reusable/DeleteConfirmation.vue";

export default {
	name: "CartItem",
	props: ['item', 'options'],
	data: function () {
		return {
			uicontrol: {
				input : {
					show : true
				}
			}
		}
	},

	components : {
		DeleteConfirmation,
		QuantityControl,
		Link
	},

	computed : {
		quantity : {
			get() {
				return parseInt(this.item.quantity);
			},
			set(value) {
				// this.item.quantity = value;
				this.$store.dispatch('cart/setItemQuantity', {
					item_uuid : this.item.uuid,
					quantity : parseInt(value)
				})
			}
		}
	},

	methods: {

		showDeleteConfirmation() {
			// Emit an the parent component, so that it can hide the delete confirmation on other items
			this.emitter.emit('cartItemDeleteButtonClicked', this.item.uuid);
		}

	}
}
</script>